// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YGDd4","badges":"styles_badges__1pxWj"};